import styled, { css } from 'styled-components';
import { PANDA_COLORS } from '../../../panda';

export const SelectionSection = styled.div`
  margin-bottom: 20px;
`;

export const SelectionTitleMixin = css`
  color: ${PANDA_COLORS.white};
  display: block;
  margin-bottom: 8px;
`;

export const ButtonContainer = styled.div<{ isClone: boolean }>`
  color: white;
  margin-bottom: 8px;
  border: 1px solid rgba(255, 255, 255, 0.3);

  font-size: 14px;
  height: 40px;
  padding: 0 15px;
  border-radius: 8px;
  align-items: center;
  display: flex;
  justify-content: center;
  outline: none;

  svg {
    color: white;
  }

  ${(props) =>
    props.isClone
      ? `
      background-color: #292940;
      cursor: grabbing;
    `
      : `&:hover {
    background-color: rgba(255, 255, 255, 0.3);
    cursor: pointer;
  }`}
`;

export const OptionContainer = styled.div`
  position: relative;
`;
